import LegalPage from '@/components/LegalPage';

const privacyPolicyContent = `# SeekScape — Privacy Policy

**Effective Date:** April 6, 2026

## 1. Introduction

SeekScape ("we," "our," "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use the SeekScape application ("App").

## 2. Information We Collect

### 2.1 Wallet Information
- **Public Wallet Address:** When you connect your Solana wallet, we store your public wallet address to identify your account, manage purchases, and provide personalized features (favorites, library, purchase history).
- **We never collect or store your private keys or seed phrases.**

### 2.2 Usage Data
- Wallpaper browsing history and preferences
- Purchase and download records
- Favorites and library data
- Device type and screen resolution (to optimize wallpaper delivery)

### 2.3 Blockchain Data
- Transaction records related to purchases made through the App are publicly recorded on the Solana blockchain. This data is inherently public and not controlled by SeekScape.

## 3. How We Use Your Information

We use collected information to:
- Process wallpaper purchases and deliver content
- Maintain your library, favorites, and purchase history
- Improve App performance and user experience
- Display relevant wallpaper recommendations
- Prevent fraud and enforce our terms

## 4. Data Storage and Security

- User data is stored securely using encrypted database systems
- We implement industry-standard security measures to protect your information
- Wallpaper files are delivered through secure, authenticated channels
- We do not sell, rent, or share your personal data with third parties for marketing purposes

## 5. Blockchain Transparency

All purchase transactions occur on the Solana blockchain and are publicly visible. SeekScape does not control blockchain data. Your wallet address and transaction history on-chain are inherently public.

## 6. Third-Party Services

The App may interact with:
- **Solana Blockchain:** For processing transactions
- **Wallet Providers:** For authentication and transaction signing
- **Content Delivery Networks:** For serving wallpaper images

These services have their own privacy policies, and we encourage you to review them.

## 7. Data Retention

- Account data is retained as long as your wallet remains connected to SeekScape
- Purchase records are maintained indefinitely to ensure continued access to purchased content
- You may request deletion of non-essential data by contacting us

## 8. Your Rights

You have the right to:
- Access information we hold about your account
- Request correction of inaccurate data
- Request deletion of your data (subject to purchase record retention)
- Disconnect your wallet and stop using the service at any time

## 9. Children's Privacy

SeekScape is not intended for users under the age of 13. We do not knowingly collect information from children.

## 10. Changes to This Policy

We may update this Privacy Policy from time to time. Changes will be effective upon publication within the App. Continued use constitutes acceptance.

## 11. Contact

For privacy-related inquiries, please reach out through the SeekScape application.`;

export default function PrivacyPolicyPage() {
  return <LegalPage title='Privacy Policy' content={privacyPolicyContent} />;
}
